"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AccordionContainer;
var _react = _interopRequireWildcard(require("react"));
var _accordionHelper = require("../../utils/accordionHelper");
var _classnames = _interopRequireDefault(require("classnames"));
var _accordionContainerModule = _interopRequireDefault(require("./accordionContainer.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function AccordionContainer(props) {
  var _detailsRef$current;
  var detailsRef = (0, _react.useRef)(null);
  var contentRef = (0, _react.useRef)(null);
  var summaryRef = (0, _react.useRef)(null);
  var accordionHook = (0, _accordionHelper.useAccordion)(detailsRef, summaryRef, contentRef);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: _accordionContainerModule["default"].accordionContainer,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("details", {
      ref: detailsRef,
      onClick: accordionHook.handleClick,
      className: (0, _classnames["default"])(_accordionContainerModule["default"].details, _defineProperty({}, _accordionContainerModule["default"].chevronUp, accordionHook.isChevronUp)),
      "data-event": !((_detailsRef$current = detailsRef.current) !== null && _detailsRef$current !== void 0 && _detailsRef$current.open) ? 'accordionOpen' : null,
      "data-name": props.title,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("summary", {
        ref: summaryRef,
        className: _accordionContainerModule["default"].label,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: props.title
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _accordionContainerModule["default"].content,
        ref: contentRef,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _accordionContainerModule["default"].innerContainer,
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          children: props.children
        })
      })]
    })
  });
}